import type { PropsWithChildren } from 'react';
import React, { memo, useRef } from 'react';
import useMeasure from 'react-use/lib/useMeasure';
import { useDebounce } from 'use-debounce';

const reverseStyle = {
  transform: 'scaleY(-1)',
};

interface Props {
  reverse?: boolean;
  waitForInitialHeight?: boolean;
  frameLimit?: number;
}

export const ThreadAutoHeight: React.FC<PropsWithChildren<Props>> = memo(function ThreadAutoHeight(
  props,
) {
  const { children, reverse, waitForInitialHeight = false, frameLimit = 3 } = props;
  const [ref, { height }] = useMeasure<HTMLDivElement>();
  const didMountRef = useRef(0);
  const [debouncedHeight] = useDebounce(height, 16, { trailing: true });
  const diffCountRef = useRef(0);
  if (height === debouncedHeight) {
    diffCountRef.current = 0;
  } else {
    diffCountRef.current += 1;
  }

  const cssHeight = !didMountRef.current || diffCountRef.current > frameLimit ? 'auto' : height;

  didMountRef.current = Number(didMountRef.current || !waitForInitialHeight || height);

  return (
    <div
      style={{
        height: cssHeight,
        ...(reverse ? reverseStyle : null),
      }}
      className="transition-all duration-150"
    >
      <div ref={ref} style={reverse ? reverseStyle : undefined}>
        {children}
      </div>
    </div>
  );
});
